import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_config",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "grid-content bg-purple" }
const _hoisted_9 = {
  class: "d-flex flex-stack fs-6 fw-bold mb-1",
  "data-v-9d4a844a": ""
}
const _hoisted_10 = {
  class: "symbol symbol-50px me-6",
  "data-v-9d4a844a": ""
}
const _hoisted_11 = {
  class: "d-flex flex-column",
  "data-v-9d4a844a": ""
}
const _hoisted_12 = {
  class: "fs-6",
  "data-v-9d4a844a": ""
}
const _hoisted_13 = {
  class: "fs-7 text-muted",
  "data-v-9d4a844a": ""
}
const _hoisted_14 = { class: "modal-footer flex-center" }
const _hoisted_15 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_16 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.configData,
          ref: "addConfigForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t("message.ADD")} ${_ctx.$t("message.SYSTEM")} ${_ctx.$t("message.CONFIGURATION")}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: "text",
                  name: "name",
                  label: _ctx.$t('message.NAME'),
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                  requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.configData.name = $event)),
                  target: "name",
                  required: true,
                  value: _ctx.configData.name
                }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"]),
                _createVNode(_component_Select, {
                  name: "site_id",
                  target: "site_id",
                  required: true,
                  label: _ctx.$t('message.SITES'),
                  placeholder: _ctx.$t('message.SELECT'),
                  site_id: _ctx.configData.site_id,
                  "onUpdate:site_id": _cache[2] || (_cache[2] = ($event: any) => (_ctx.configData.site_id = $event)),
                  selectData: _ctx.sites,
                  value: _ctx.configData.site_id,
                  callEmit: true,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSite(_ctx.configData.site_id)))
                }, null, 8, ["label", "placeholder", "site_id", "selectData", "value"]),
                _createVNode(_component_Select, {
                  name: "country_id",
                  target: "country_id",
                  label: _ctx.$t('message.COUNTRY'),
                  required: true,
                  placeholder: _ctx.$t('message.SELECT'),
                  country_id: _ctx.configData.country_id,
                  "onUpdate:country_id": _cache[4] || (_cache[4] = ($event: any) => (_ctx.configData.country_id = $event)),
                  selectData: _ctx.countries,
                  value: _ctx.configData.country_id,
                  callEmit: true,
                  disabled: true
                }, null, 8, ["label", "placeholder", "country_id", "selectData", "value"])
              ]),
              (_ctx.showCountryInfo)
                ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.showCountryInfo[0], (info, index) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          span: 12,
                          key: index,
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("div", _hoisted_8, [
                              _createVNode("label", _hoisted_9, [
                                _createVNode("span", _hoisted_10, [
                                  _createVNode("span", _hoisted_11, [
                                    _createVNode("span", _hoisted_12, _toDisplayString(index), 1),
                                    _createVNode("span", _hoisted_13, _toDisplayString(info), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("button", _hoisted_15, _toDisplayString(_ctx.$t("message.CANCEL")), 1),
              _createVNode("button", {
                disabled: _ctx.disabled,
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
              ], 8, ["disabled"])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}